import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import md5 from 'md5';
import { APP_NAME, APP_VERSION } from '../app-info';
import { Account } from '../class/Account';
import { Company } from '../class/Company';
import { AccountStateService } from './account-state.service';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { LoadingService } from './loading.service';
import { LocalStorageService } from './local-storage.service';
import { MapService } from './map.service';
import { PostauthService } from './postauth.service';
import { PosthogService } from './posthog.service';
import { PreauthService } from './preauth.service';
import { SiteListService } from './sitelist.service';
import { lastValueFrom } from 'rxjs';

interface Person {
  user: string;
  password: string;
  md5Password: string;
  save: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class ConnectionService extends BaseService<Object> {
  public person: Person = {
    user: '',
    password: '',
    md5Password: undefined,
    save: false,
  };

  public $errMsg = signal<'connection' | 'wrongId' | 'isEmpty' | 'idpRenault' | 'defaultError' | null>(null);
  public buttonDisabled = false;
  public renault = {
    code: '',
    // // BETA
    // // client_id: '22421136-c664-4f7c-8028-0f7eed765013',
    // // secret: 'Y0DslxNog_GGLQo4zolV6FOdb-fn1IizljMUvmGJGvB8Lj-KcfBz9n3VulMD3i-Wxjiv_w1heA2tww09TRuEQw',
    // // PROD
    client_id: '36cedc50-c3a4-44da-9768-869f5acb438d',
    secret: 'sQObjtWVVYbnI0qG8TFJly7t9lhM6BydHLOsmqEw7apAt0Jiujq_tsCipA_E3y-0Uy5enk0NEx5vDWUxXgCiLQ',
    id_token: '',
    acces_token: '',
    refresh_token: '',
    user: {},
  };
  public errCodeIDP = '';
  public isRenault = false;
  public isLoaderReconnect = false;

  private _accountStateService = inject(AccountStateService);
  private loadingService = inject(LoadingService);
  private preauthService = inject(PreauthService);
  private postauthService = inject(PostauthService);
  private _localStorageService = inject(LocalStorageService);
  private mapService = inject(MapService);
  private siteListService = inject(SiteListService);
  private router = inject(Router);
  private _authService = inject(AuthService);
  private _posthogService = inject(PosthogService);

  constructor() {
    super(inject(ApiService));
  }

  public validate() {
    this.$errMsg.set(null);
    this.preauthService.Get('preauth', { u: this.person.user, p: this.person.md5Password }, true).subscribe(
      preauthdata => this.setAccounts(preauthdata),
      err => {
        this.ValidateHandleError(err);
        this._posthogService.captureEvent('preauth failed', { source: 'service', from: 'connection' });
      },
      () => {
        console.log('Authentication Successfull');
        this.mapService.init = true;
        this._authService.isLoggedIn = true;
        this._authService.connecting = true;
        this._accountStateService.setAccountConnect({
          save: this.person.save,
          email: this.person.user,
          password: this.person.md5Password,
        });
      }
    );
  }

  public passwordToMd5(password: string): string {
    return password ? md5(password) : '';
  }

  public renaultValidate() {
    this.$errMsg.set(null);
    this.errCodeIDP = '';

    // Reverting to old IDP for a bit
    // this.preauthService
    //   .Get("preauth", {
    //     u: "johndoe@renault.com",
    //     p: this.renault.code,
    //     renault: true,
    //   })
    //   .subscribe(
    //     (preauthdata) => {this.setAccounts(preauthdata)},
    //     (err) => {
    //       this.errCodeIDP = err;
    //       this.errMsg = 'idpRenault';
    //       this.buttonDisabled = false;
    //     },
    //     () => {
    //       console.log("Authentication Renault Successfull");
    //       this.mapService.init = true;
    //       this.isRenault = true;
    //     },
    //   );

    const data =
      'grant_type=authorization_code&code=' +
      this.renault.code +
      '&client_id=' +
      this.renault.client_id +
      '&client_secret=' +
      this.renault.secret +
      '&redirect_uri=https://app.ubiwan.net/auth/renault';
    const url = 'https://idp.renault.com/nidp/oauth/nam/token';

    fetch(url, {
      method: 'POST',
      headers: {
        Accept: '*/*',
        'Accept-Encoding': 'gzip, deflate, br',
        'Accept-Language': 'fr-FR,fr;q=0.9,en-US;q=0.8,en;q=0.7',
        Connection: 'keep-alive',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        // 'Host': 'idp.aitslab.com',
        Host: 'idp.renault.com',
        Origin: 'https://app.ubiwan.net',
        'Sec-Fetch-Mode': 'cors',
        'Sec-Fetch-Site': 'same-site',
      },
      body: data,
    })
      .then(response => response.json())
      .then(response => {
        if (response.access_token) {
          const payload = JSON.parse(window.atob(response.access_token.split('.')[1]));
          if (payload['role-ubw-irn71682'] && this.isAuthorized(payload['role-ubw-irn71682']) === true) {
            this.renault.acces_token = response.access_token;
            this.renault.id_token = response.id_token;
            this.preauthService
              .Get(
                'preauth',
                {
                  u: 'dummy@renault.com',
                  p: this.renault.acces_token,
                  renault: true,
                },
                true
              )
              ////////////////////////////////////////////////////////////
              .subscribe(
                preauthdata => this.setAccounts(preauthdata),
                err => {
                  this.ValidateHandleErrorRenault(err);
                },
                () => {
                  console.log('Authentication Renault Successfull');
                  this._authService.connecting = true;
                  this.mapService.init = true;
                  this.isRenault = true;
                }
              );
          } else {
            this.$errMsg.set('connection');
            console.log('Invalid Authentication');
          }
        } else {
          this.$errMsg.set('connection');
          console.log('Error Authentication');
        }
      })
      .catch(error => {
        this.ValidateHandleErrorRenault(error);
        console.log('Erreur : ' + error);
      });
  }

  public isAuthorized(role: string): boolean {
    return /ubw (users|admins)/.test(role);
  }

  public googleValidate(email: string, token: string) {
    this.buttonDisabled = true;
    this.$errMsg.set(null);
    this.preauthService.Get('preauth', { u: email, p: token, gauth: 'true' }, true).subscribe(
      preauthdata => {
        this.setAccounts(preauthdata);
      },
      err => {
        this.ValidateHandleError(err);
      },
      () => {
        console.log('Authentication Successfull');
        this.mapService.init = true;
        this._authService.connecting = true;
      }
    );
  }

  private ValidateHandleError(err: any) {
    this.buttonDisabled = false;
    this.$errMsg.set('connection');
    this.isLoaderReconnect = false;
  }

  private ValidateHandleErrorRenault(err: any) {
    this.buttonDisabled = false;
    this.$errMsg.set('idpRenault');
  }

  private setAccounts(preauthdata: { accounts: Account[]; token: string }) {
    if (preauthdata.accounts?.length === 1 && !preauthdata.accounts?.[0]?.supervisor) {
      this.validateAccount(preauthdata.accounts?.[0]);
    } else {
      this._accountStateService.setAccountsList(preauthdata.accounts);
      this._authService.setLoginState('accounts');
      this.router.navigate(['/supervisor']);
    }
  }

  public validateAccount(account: Account) {
    // this.mapService.init = true; //->deja initialisé
    //default value of account type = 1, btp could be 2
    //account is stored in localStorage and storageService later
    //so account_type can be accessed via storageService.account.account_type
    //TODO: react in CSS according to loaded accountType
    this._accountStateService.setAccount(account);
    let posttoken: string;
    this.postauthService
      .Get(
        'postauth',
        {
          t: account.t,
          token: account.pretoken,
          app: APP_NAME,
          version: APP_VERSION,
        },
        true
      )
      .subscribe(
        response => {
          posttoken = response['token'];
        },
        err => {
          console.log(err);
          LocalStorageService.clearAll();
          this.loadingService.logout();
        },
        () => {
          this._authService.$token.set(posttoken);
          if (account.supervisor) {
            this.getCompanies(posttoken);
          } else {
            this._accountStateService.setAccount(account);
            this.initAppWithAccount(account);
          }
        }
      );
  }

  public getCompanies(token: string) {
    let siteList: Company[] = [];
    this.siteListService.Get('site', { action: 'read', token: token }).subscribe(
      response => {
        siteList = response;
      },
      err => {
        console.log(err);
        this.loadingService.logout();
      },
      () => {
        this._accountStateService.setCompanyList(siteList);
        this._authService.setLoginState('sites');
      }
    );
  }

  public validateCompany(company: Company) {
    let postAccount: Account;
    this.postauthService
      .Get(
        'postauth',
        {
          t: this._accountStateService.$account().t,
          uid_site: String(company.uid),
          token: this._authService.$token(),
          app: APP_NAME,
          version: APP_VERSION,
        },
        true
      )
      .subscribe(
        response => {
          postAccount = response.account;
        },
        err => {
          console.log(err);
          LocalStorageService.clearAll();
          this.loadingService.logout();
        },
        () => {
          //set companyId to for accountHash in storageService
          this._accountStateService.setCompany(company);
          const account = postAccount;
          account.uid_site = company.uid;
          account.account_type = company.account_type;
          this._accountStateService.setAccount(account);
          this._accountStateService.setCompanyList(null);

          this._localStorageService.storeElement('accountData', account);
          this.initAppWithAccount(account);
        }
      );
  }

  private initAppWithAccount(account: Account) {
    const company = this._accountStateService.$company();
    if (company && company.uid !== account.uid_company) {
      this.loadingService.clearData();
      this._accountStateService.setAccount(account);
      this._authService.$token.set(account.pretoken);
    }

    this.loadingService.initAppWithAccount(true);
  }

  public async sendMailForResetPassword(email: string): Promise<string> {
    const result = await lastValueFrom(this.Get('password_reset_request', {
      mail: email,
    }));
    return Promise.resolve('SUCCESS');
  }

  public async resetPassword(
    passwordData: string,
    tokenData: string
  ): Promise<'SUCCESS_PASSWORD' | 'INVALID_PASSWORD' | 'ERROR_RESET_PASSWORD' | 'ERROR'> {
    const result = await lastValueFrom(this.Get('password_reset', {
      password: this.passwordToMd5(passwordData),
      token: tokenData,
    }));
    let mess: 'SUCCESS_PASSWORD' | 'INVALID_PASSWORD' | 'ERROR_RESET_PASSWORD' | 'ERROR';
    // POSSIBLE ERROR : INVALID_PASSWORD || ERROR_RESET_PASSWORD
    if (result?.['result'] === 201) {
      mess = result?.['passwordreset'].success === true ? 'SUCCESS_PASSWORD' : 'ERROR_RESET_PASSWORD';
    } else {
      mess = result?.['passwordreset']?.error ? 'ERROR' : 'ERROR_RESET_PASSWORD';
    }
    return Promise.resolve(mess);
  }

  public override HandleResponse(response: JSON): Object {
    return response;
  }
}
